import gettingStartedContent from '../assets/getting_started_content.svg';
import gettingStartedVideo from '../assets/getting_started_video.svg';
import gettingStartedEdited from '../assets/getting_started_edited.svg';
import gettingStartedMasterpiece from '../assets/getting_started_masterpiece.svg';
import gettingStartedAcademy from '../assets/getting_started_academy.svg';
import EXTERNAL_LINKS from '../../../constants/externalLinks';

type GettingStartedStep = {
  link: string;
  svgImageElement: string;
  stepKey: string;
  href: string;
};

const STEPS: GettingStartedStep[] = [
  {
    link: 'Plan your content',
    svgImageElement: gettingStartedContent,
    stepKey: 'content',
    href: EXTERNAL_LINKS.planYourContentURL
  },
  {
    link: 'Shoot your video',
    svgImageElement: gettingStartedVideo,
    stepKey: 'video',
    href: EXTERNAL_LINKS.shootYourVideoURL
  },
  {
    link: 'Get your video edited',
    svgImageElement: gettingStartedEdited,
    stepKey: 'edited',
    href: EXTERNAL_LINKS.getYourVideoEditedURL
  },
  {
    link: 'Share your masterpiece',
    svgImageElement: gettingStartedMasterpiece,
    stepKey: 'masterpiece',
    href: EXTERNAL_LINKS.shareYourMasterpieceURL
  },
  {
    link: 'Shootsta Learning Academy',
    svgImageElement: gettingStartedAcademy,
    stepKey: 'academy',
    href: EXTERNAL_LINKS.shootstaLearningAcademyURL
  }
];

export default STEPS;
